<!--
 * @Description: 学生学习记录
 * @Author: PF
 * @Date: 2025-10-27 16:22:24
 * @LastEditors: PF
 * @LastEditTime: 2025-11-27 09:27:57
-->
<template>
  <div>
    <el-dialog class="wp90 hp90" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <List />
          </el-icon>
          <span class="header-title">学生学习记录</span>
        </div>
        <div class="header-right"> 
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <list :row="tcrow" />
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { homeCloseWindow } from '@/api/common.js'
import list from '@/pages/wangluokecheng/wangluokecheng/xueshengxuexijilu/list.vue'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

const openList = ref(false)
const tcrow = ref()
watch(
  () => props.open,
  () => {
    if (props.open === 'xueshengxuexijilu') {
      openList.value = true
      tcrow.value = {
        isJs: JSON.parse(sessionStorage.getItem('USER_INFO')).id
      }
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)

</script>
<style scoped>
:deep(.el-dialog__body) {
  padding: 0;
}
</style>